import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../taboola-common-frontend-modules/i18n';
import styles from './CampaignGroupTooltip.module.scss';

export const CampaignGroupTooltip = ({ onCreateGroup, helpLink }) => (
    <div className={styles.tooltipContainer}>
        <div className={styles.titleContainer}>
            <span className={styles.emoji}>👋</span>
            <h3 className={styles.title}>
                <FormattedMessage
                    id="app.campaigns.create.button.title"
                    defaultMessage="First, create a campaign group"
                />
            </h3>
        </div>
        <div className={styles.messageContainer}>
            <FormattedMessage
                id="app.campaigns.create.button.message"
                defaultMessage="Campaigns are now organized into groups with a shared goal. To continue, create a campaign group."
            />
            <a href={helpLink} target="_blank" rel="noopener noreferrer" className={styles.learnMoreLink}>
                <FormattedMessage id="app.campaigns.create.button.learn.more" defaultMessage="Learn more" />
            </a>
        </div>
        <button onClick={onCreateGroup} className={styles.button}>
            <FormattedMessage id="app.campaigns.create.button.create" defaultMessage="Create campaign group" />
        </button>
    </div>
);

CampaignGroupTooltip.propTypes = {
    onCreateGroup: PropTypes.func.isRequired,
    helpLink: PropTypes.string.isRequired,
};
